import type { Element } from "React";
import { Component } from "react";
import Dropdown from "react-bootstrap-timezone-picker";
import "react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css";
import { Timezones } from "../../utils/timezones";
import "./TimezoneDropdown.scss";
type Props = {
  onChange: (...args: Array<any>) => any;
  defaultValue: Record<string, any>;
};

class TimezoneDropdown extends Component<Props> {
  componentDidMount() {
    // Timezone picker uses a FormControl component for it's input
    // which uses a focus event to handle opening the list
    const dropdown = document.querySelector(".form-control");

    let simulateFocus = (elem: any) => {
      let evt = new Event("focus", {
        bubbles: true,
      });
      elem.dispatchEvent(evt);
    };

    simulateFocus(dropdown);
  }

  render(): Element<"div"> {
    const { onChange, defaultValue } = this.props;
    return (
      <div className="timezone-dropdown">
        <Dropdown
          absolute={true}
          defaultValue={defaultValue.label}
          placeholder="Search..."
          onChange={onChange}
          timezones={Timezones}
          id={"timezone-dropdown"}
        />
      </div>
    );
  }
}

export default TimezoneDropdown;
